module.exports = __webpack_public_path__ + "static/media/icon-search-white.1acd782b.svg";